<template>
    <b-alert
        :show="true"
        :fade="true"
        dismissible
        variant="primary"
        :class="['nav-alert', 'alert-'+blok.style]"
      >{{ blok.label }}</b-alert>
</template>
<script>
export default {
    name: 'navigation-alert',
    props: {
        blok: Object
    }
}
</script>